import { SECTORS } from "../data/store";
import { ProductCard } from "./ProductCard";
import { Loader2, SearchX, Heart } from "lucide-react";
import { useFavorites } from "../context/FavoritesContext";

export const ProductCatalog = ({ products, loading, activeSector, setActiveSector, search, onlyFavs, setOnlyFavs }) => {
  const { count: favCount } = useFavorites();

  return (
    <section id="section-catalog" className="scroll-mt-20 py-14 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <div className="text-xs font-bold tracking-widest uppercase text-[#E02424]">Catálogo</div>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900">
              {onlyFavs ? "Tus favoritos" : "Nuestros productos"}
            </h2>
          </div>
        </div>

        {/* Sector filter */}
        <div className="flex flex-wrap gap-2 mb-8" data-testid="sector-filters">
          <button
            data-testid="filter-todos"
            onClick={() => setActiveSector("")}
            className={`px-4 py-2 rounded-full text-sm font-bold border transition-colors ${
              activeSector === "" ? "bg-[#0A3977] text-white border-[#0A3977]" : "bg-white text-gray-700 border-gray-300 hover:border-[#0067B1]"
            }`}
          >
            Todos
          </button>
          {SECTORS.map((s) => (
            <button
              key={s.key}
              data-testid={`filter-${s.key}`}
              onClick={() => setActiveSector(s.key)}
              className="px-4 py-2 rounded-full text-sm font-bold border transition-colors"
              style={
                activeSector === s.key
                  ? { background: s.color, color: "#fff", borderColor: s.color }
                  : { background: "#fff", color: s.text, borderColor: s.border }
              }
            >
              {s.label}
            </button>
          ))}
          <button
            data-testid="filter-favoritos"
            onClick={() => setOnlyFavs(!onlyFavs)}
            aria-pressed={onlyFavs}
            className={`ml-auto inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold border transition-colors ${
              onlyFavs ? "bg-[#E02424] text-white border-[#E02424]" : "bg-white text-[#E02424] border-red-200 hover:border-[#E02424]"}`}
          >
            <Heart className={`w-4 h-4 ${onlyFavs ? "fill-current" : ""}`} /> Favoritos
            {favCount > 0 && <span className={`font-mono-code text-xs ${onlyFavs ? "opacity-80" : "text-gray-400"}`}>{favCount}</span>}
          </button>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-24 text-gray-400">
            <Loader2 className="w-8 h-8 animate-spin" />
          </div>
        ) : products.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 text-gray-400" data-testid="catalog-empty">
            {onlyFavs ? <Heart className="w-10 h-10 mb-3" /> : <SearchX className="w-10 h-10 mb-3" />}
            <p className="font-semibold">
              {onlyFavs ? "Todavía no guardaste favoritos. Tocá el corazón de un producto para guardarlo." : `No encontramos productos${search ? ` para "${search}"` : ""}.`}
            </p>
          </div>
        ) : (
          <div
            data-testid="product-grid"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
          >
            {products.map((p, i) => (
              <ProductCard key={p.id || p.code} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
